<template>
  <div id="app">
    <router-view></router-view>
    <iframe :id="iframeId" :src="iframeSrc" style="display:none;"></iframe>
  </div>
</template>

<script>
export default {
  name: "app",
  computed: {
    iframeId: () => "ifrm",
    iframeSrc: () => process.env.WEB_API_ORIGIN + "/index.html"
  },
  created: function() {
    // GoogleAnalytics初期処理
    rosettaGA.initialize(process.env.GA_TRACKING_ID);
  }
};
</script>

<style lang="scss">
@import "src/assets/style/normalize";
@import "src/assets/style/common";
</style>



// WEBPACK FOOTER //
// App.vue?6722bcc3